import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud'; // Ajusta según tu estructura
import { useUsers } from '../../../metodos/userContext';
import { formatearFechaCompleta, formatearPrecio} from '../../../utils/utils'; // Importamos desde el archivo utils.js
import { 
  Edit3, 
  AlertTriangle,
  DollarSign, 
  Bell, 
  Eye, 
  FileText,
  AlertCircle,
  Clock,
  User,
  Info,
} from 'lucide-react';
import ConfirmationDialog from '../../../utils/confirmacionDialog'; // Asegúrate de crear este componente
import { useFormOptions } from '../../.././config/constants';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import ModalCotizar from '../../../views/tutorRoute/tutorCotizar';
import ModalServicioAgendado from '../../../views/adminRoute/Solicitudes/Agendas/ModalTrabajoAgendado';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import ModalAgendarTrabajo from '../../../views/adminRoute/Solicitudes/Agendas/ModalAgendarTrabajo';
import { useisUserAdmin, useisUserCliente, useisUserTutor, useNombreEmpresaReal } from '../../../config/unificacion';
import ModalCopiarSolicitud from './Modulos/CopiarSolicitud';
import { BotonVolver } from '../../../utils/navigator';
import { useDialog } from '../../../components/Dialogs/Dialogprovider';
import AdminView from './Vistas/AdminView';
import ClienteView from './Vistas/ClienteView';
import TutorView from './Vistas/TutorView';
import HeaderSolicitudes from './Vistas/HeaderView';

const DetallesSolicitudes = () => {
  // Obtener parámetros de la URL
  const {nombreEmpresa, idSolicitud } = useParams();
  const [showModalAgendar, setShowModalAgendar] = useState(false);
  const [cotizacionSeleccionada, setCotizacionSeleccionada] = useState(null);

  //edicion
  let nombreEmpresaReal = useNombreEmpresaReal(nombreEmpresa);
  const {usuario} = useUsers();

  //ROLES
  const isAdmin = useisUserAdmin(usuario);
  const isTutor = useisUserTutor(usuario);
  const isCliente = useisUserCliente(usuario);

  const navigate = useNavigate();
  const [showModalCotizar, setShowModalCotizar] = useState(false);
  const [haCotizado, setHaCotizado] = useState(false);
  const [cotizacionUsuario, setCotizacionUsuario] = useState(null);
  const {tipoServiciosListAdmin , estadoSolicitudVisibles , } = useFormOptions();
  
  const [showModalExito, setShowModalExito] = useState(false);
  const [servicioDataRetornado, setServicioDataRetornado] = useState(null);

  //modal copia servicios
  const [showModalCopia, setShowModalCopia] = useState(false);

  //dialogs
  const dialogs = useDialog();
  
  const {
    materiasOptions,
    cargarMaterias,
  } = useListasModel();

  const { 
    configuracion, 
  } = useConfiguracion();

  const {
    cliente,
    getCliente,
    busquedaClientesOptions,
    handleInputChange,
    loadingClientes
  } = useClientesModel();

  const {
    addNewSolicitud,
    solicitud,
    nuevaCotizacion,
    loadingSolicitudes,
    errorSolicitudes,
    cargarSolicitudPorId,
    handleInputChangeCotizacion,
    addNewCotizacion,
    setupWebSocketsSolicitudes,
    rechazarSolicitud,
    actualizarSolicitud,
    deleteCotizacion,
    confirmDialog, 
    closeConfirmDialog ,
  } = useDetalleSolicitudModel();

  const location = useLocation();

  //Agregar control de ejecuciones
  const hasViewedRef = useRef(false);
  const isLoadingRef = useRef(false);

  //cargar materias
  useEffect(() => {
    cargarMaterias();
    }, []);

  // cargando solicitud
  useEffect(() => {
    if (!idSolicitud || !nombreEmpresaReal || isLoadingRef.current) return;
    
    isLoadingRef.current = true;
    
    const cargarYConfigurarSolicitud = async () => {
      try {
        // Cargar la solicitud
        const solicitudObjeto = await cargarSolicitudPorId(idSolicitud, nombreEmpresaReal);
        
        // Configurar WebSockets
        const cleanupWebSockets = setupWebSocketsSolicitudes(solicitudObjeto, nombreEmpresaReal);
        
        return cleanupWebSockets;
      } catch (error) {
        console.error("Error cargando solicitud:", error);
      } finally {
        isLoadingRef.current = false;
      }
    };
    
    const cleanup = cargarYConfigurarSolicitud();
    
    return () => {
      cleanup.then(cleanupFn => cleanupFn && cleanupFn());
    };
  }, [idSolicitud, nombreEmpresaReal]);

  //cotizaciones, vista de tutor y cargar cliente
  useEffect(() => {
  if (!solicitud || !usuario) return;
  
  const procesarSolicitudYUsuario = async () => {
    // 1. Verificar cotizaciones (solo para tutores)
    if (usuario.rol === "TUTOR" && solicitud.cotizaciones) {
      const cotizacion = solicitud.cotizaciones.find(
        cot => cot.nombretutor === usuario.nombrewhatsapp
      );
      
      if (cotizacion) {
        setHaCotizado(true);
        setCotizacionUsuario(cotizacion);
      } else {
        setHaCotizado(false);
        setCotizacionUsuario(null);
      }
    }
    
    // 2. Verificar si ya vio la solicitud (solo para tutores y una sola vez)
    if (usuario.rol === "TUTOR" && solicitud.tutorVistaSolicitud && !hasViewedRef.current) {
      const vista = solicitud.tutorVistaSolicitud.find(
        vistatutor => vistatutor.nombreTutor === usuario.nombrewhatsapp
      );
      
      if (vista) {
        console.log("ya lo vio");
        hasViewedRef.current = true;
      } else {
        console.log("no lo ha visto");
        console.log("el usuario cargado", usuario);
        
        // Marcar como visto antes de hacer la actualización
        hasViewedRef.current = true;
        
        const updateData = {
          'nombreTutor': usuario.nombrewhatsapp,
          'fechaConfirmacion': new Date(),
        };
        
        try {
          await actualizarSolicitud(
            solicitud.id,
            nombreEmpresaReal,
            'tutorVistaSolicitud',
            updateData,
            'array_insert'
          );
        } catch (error) {
          console.error("Error actualizando vista del tutor:", error);
          // Resetear en caso de error
          hasViewedRef.current = false;
        }
      }
    }
    
    // 3. Cargar cliente si existe
    if (solicitud.cliente) {
      try {
        //vamos a buscar el cliente, dependiendo de quien sea el referido
        const empresaReferida = solicitud.referidoPor;
        let empresaBusquedaCliente = '';
        if(empresaReferida == ""){
          empresaBusquedaCliente = nombreEmpresaReal;
        } 
        else{
          if (nombreEmpresa === 'DUFY_ASESORIAS') {
            empresaBusquedaCliente = empresaReferida.replace(/_/g, ' ');
          }else{
            empresaBusquedaCliente = empresaReferida;
          }
        }
        
        const clienteCargado = await getCliente(empresaBusquedaCliente, solicitud.cliente);
        console.log("Cliente cargado:", clienteCargado);
      } catch (error) {
        console.error("Error cargando cliente:", error);
      }
    }
  };
  
  procesarSolicitudYUsuario();
}, [solicitud, usuario, nombreEmpresaReal]);

  //limpiar refs cuando el componente se desmonte
  useEffect(() => {
  return () => {
    hasViewedRef.current = false;
    isLoadingRef.current = false;
  };
  }, [idSolicitud, usuario?.nombrewhatsapp]);

  const handleCloseModal = useCallback(() => {
    setShowModalCotizar(false);
  }, []);

  // Función para volver atrás
  const handleRegresar = () => {
    if (location.key !== 'default') {
      navigate(-1); 
    } else {
      navigate('/dashboard'); 
    }
  };

  const addNewCotizacionLocal = useCallback(async (e) => {
    e.preventDefault();
    try {
      await addNewCotizacion(nombreEmpresaReal);
      setShowModalCotizar(false);
    } catch (error) {
      console.error("Error al enviar cotización:", error);
    }
  }, [addNewCotizacion, nombreEmpresaReal]);

  //Eliminar cotizacion
  const deleteCotizacionLocal = async(cotizacion) =>{
    console.log("eliminar cotizacion",cotizacion);
    deleteCotizacion(nombreEmpresaReal,solicitud.id,cotizacion);
  
  }

  //Agendar trabajo
  const agendarTrabajo = async(cotizacion) => {
    setCotizacionSeleccionada(cotizacion);
    setShowModalAgendar(true);
  }

  const handleSave = async (field, value) => {

    if(field == "fechaentrega"){
      const fechaNueva = new Date(value);
      const fechaActual = new Date();

      if (fechaNueva < fechaActual) {

        const onConfirmarCambio = () => {
          console.log("Usuario confirmó fecha pasada:", field, value);
          actualizarSolicitud(solicitud.id,nombreEmpresaReal,field,value,'field')
          dialogs.showSuccess('Fecha de entrega actualizada correctamente.');
          };

          dialogs.showConfirm(
            `Estás asignando una fecha de entrega en el PASADO (${formatearFechaCompleta(value)}). ¿Estás seguro de que deseas continuar?`,
            onConfirmarCambio, // Callback simple
            'Advertencia de fecha' // Título
          );
          
          return;

      }

    }

    console.log("actualizar cosas",field,value);

    await actualizarSolicitud(solicitud.id,nombreEmpresaReal,field,value,'field')
  
  }

  //manejo de preguntas, agregando preguntas existentes a la pregunta, lo mejor
  const handleEnviarPregunta = async (preguntasActualizadas) => {
    await actualizarSolicitud(solicitud.id, nombreEmpresaReal, 'preguntas', preguntasActualizadas, 'field');

  };

  const auxiliarBusqueda = (field, selectedOption, inputValue) => {
    console.log("auxiliar busqueda",field,selectedOption,inputValue);
    handleInputChange(selectedOption);
  }
    

  // Si está cargando, mostrar indicador de carga
  if (loadingSolicitudes) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Cargando detalles de la solicitud...</p>
      </div>
    );
  }
  
  // Si hay error o no hay solicitud, mostrar mensaje de error
  if (errorSolicitudes || !solicitud) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto">
        <div className="text-center">
          <div className="bg-red-100 text-red-800 p-4 rounded-lg mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-2 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-xl font-bold mb-2">Error al cargar la solicitud</h2>
            <p className="mb-4">No se ha podido cargar la información de esta solicitud. Puede que haya sido eliminada o no tengas acceso a ella.</p>
          </div>
          
          <button 
            onClick={handleRegresar} 
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors duration-300"
          >
            Volver a la lista de solicitudes
          </button>
        </div>
      </div>
    );
  }
    
  //solo los ADMINS pueden ver lo que sea, sin importar que
  if(solicitud.Estado && !isAdmin && !isCliente){
    const estadosNoDisponibles = ["EXPIRADO", "NO PODEMOS", "AGENDADO"];

    if (estadosNoDisponibles.includes(solicitud.Estado)) {
      return (
        <div className="p-4">
          <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4 flex items-center">
            <AlertCircle className="text-red-500 mr-2" size={20} />
            <div>
              <p className="text-red-700 font-medium">
                Esta solicitud no está disponible
              </p>
              <p className="text-red-600 text-sm">
                Estado actual: No Disponible {solicitud.id}
              </p>
            </div>
          </div>
          
          <BotonVolver
            ruta='/dashboard'
          />

        </div>
      );
    }
  }

  // ✅ CALLBACK PARA RECIBIR DATOS
  const handleServicioAgendado = (datosServicio) => {
    console.log("✅ Servicio agendado recibido:", datosServicio);
    setServicioDataRetornado(datosServicio);
    console.log("servicio data",servicioDataRetornado);
    setShowModalExito(true);
  };

  //copiar solicitud
  const copiarSolicitud = async(numeroTelefono) =>{
    console.log("Copiar solicitud al número:", numeroTelefono);

    const solicitudCopia = { ...solicitud };
    solicitudCopia.cliente = numeroTelefono;
    delete solicitudCopia.historial;

    //añadir solicitud copiada
    try{
      const nombreEmpresaSubida = configuracion?.servicios_empresas?.[solicitudCopia.Servicio];
      await addNewSolicitud(nombreEmpresaSubida,solicitudCopia);
      setShowModalCopia(false);
    }
    catch(error){
      console.error("Error al copiar la solicitud",error);
    }
    

  }

  // Renderizar la vista detallada normal si todo está bien
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-4xl mx-auto">

      <ModalServicioAgendado
        servicioDataRetornado={servicioDataRetornado}
        isOpen={showModalExito}
        onClose={() => setShowModalExito(false)}
        configuracion={configuracion}
        clienteData={cliente}
      />

      {/* ✅ AGREGAR MODAL PARA AGENDAR TRABAJO */}
      {showModalAgendar && (
        <ModalAgendarTrabajo
          showModal={true} // Siempre true cuando está montado
          onClose={() => setShowModalAgendar(false)}
          cotizacion={cotizacionSeleccionada}
          solicitud={solicitud}
          cliente={cliente}
          onServicioAgendado={handleServicioAgendado}
        />
      )}

      {/* Modal para cotizar solicitudes */}
      <ModalCotizar
        showModal={showModalCotizar}
        onClose={handleCloseModal}
        nuevaCotizacion={nuevaCotizacion}
        onInputChange={handleInputChangeCotizacion}
        onSubmit={addNewCotizacionLocal}
        servicioDataRetornado={servicioDataRetornado}
      />

      {/* Modal para rechazar confirmaciones */}
      <ConfirmationDialog 
        isOpen={confirmDialog.isOpen}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={closeConfirmDialog}
      />

      {/* Modal para copiar solicitud */}
      <ModalCopiarSolicitud
        isOpen={showModalCopia}
        onClose={() => setShowModalCopia(false)}
        onCopy={(numeroTelefono) => {
          copiarSolicitud(numeroTelefono);
        }}
      />

      {/* HEADER DE SOLICITUDES */}
      <HeaderSolicitudes 
        solicitud={solicitud}
        usuario={usuario}
        isAdmin={isAdmin}
        isTutor={isTutor}
        isCliente={isCliente}
        configuracion={configuracion}
        handleRegresar={handleRegresar}
        setShowModalCopia={setShowModalCopia}
      />

      <div className="px-6 pb-6 pt-0">
        {/* VISTA */}
        {(() => {
            if (isAdmin) {
              return (
                <AdminView
                  solicitud={solicitud}
                  usuario={usuario}
                  isAdmin={isAdmin}
                  configuracion={configuracion}
                  cliente={cliente}
                  tipoServiciosListAdmin={tipoServiciosListAdmin}
                  materiasOptions={materiasOptions}
                  busquedaClientesOptions={busquedaClientesOptions}
                  estadoSolicitudVisibles={estadoSolicitudVisibles}
                  handleSave={handleSave}
                  handleEnviarPregunta={handleEnviarPregunta}
                  auxiliarBusqueda={auxiliarBusqueda}
                  deleteCotizacionLocal={deleteCotizacionLocal}
                  addNewCotizacion={addNewCotizacion}
                  agendarTrabajo={agendarTrabajo}
                />
              );
            } else if (isTutor) {
              return (
                <TutorView
                  solicitud={solicitud}
                  usuario={usuario}
                  haCotizado={haCotizado}
                  cotizacionUsuario={cotizacionUsuario}
                  rechazarSolicitud={rechazarSolicitud}
                  setShowModalCotizar={setShowModalCotizar}
                  nombreEmpresaReal={nombreEmpresaReal}
                  isAdmin={isAdmin}
                  handleEnviarPregunta={handleEnviarPregunta}
                />
              );
            } else if (isCliente) {
              return (
                <ClienteView 
                  solicitud={solicitud}
                  isCliente={isCliente}
                  tipoServiciosListAdmin={tipoServiciosListAdmin}
                  handleSave={handleSave}
                  materiasOptions={materiasOptions}
                  auxiliarBusqueda={auxiliarBusqueda}
                  busquedaClientesOptions={busquedaClientesOptions}
                  estadoSolicitudVisibles={estadoSolicitudVisibles}
                />
              );
            }
            return <div className="p-10 text-center">No tienes permisos para ver esta solicitud.</div>;
        })()}
      </div>
      
    </div>
  );

};


export default DetallesSolicitudes;